import { ReactComponent as ZvukColorLight } from 'fym-shared/src/music-services/assets/images/zvuk-color-light.svg';
import { ReactComponent as ZvukColorDark } from 'fym-shared/src/music-services/assets/images/zvuk-color-dark.svg';
import { ReactComponent as ZvukColorLightPadding } from 'fym-shared/src/music-services/assets/images/zvuk-color-light-padding.svg';
import { ReactComponent as ZvukColorDarkPadding } from 'fym-shared/src/music-services/assets/images/zvuk-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const zvukImages: MusicServiceImages = {
  logoColor: {
    light: ZvukColorLight,
    dark: ZvukColorDark,
  },
  logoColorPadding: {
    light: ZvukColorLightPadding,
    dark: ZvukColorDarkPadding,
  },
};
